// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"0f31bd9e","667":"dd009cd3"}[chunkId] + ".chunk.js";
};